import Axios from "axios"
import { ApiResponse, handleApiErrors } from ".."
import * as Models from "./models"

const baseUrl = () => {
    return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/dooropener`
}

export async function getCodes(locationId: number): Promise<ApiResponse<Models.Data[]>> {
    return Axios.get<Models.Data[]>(`${baseUrl()}/${locationId}`)
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.Data[]>(e))
}

export async function sendTextMessage(params: Models.SendParams): Promise<ApiResponse<Models.GetCodeResult>> {
    return Axios.post<Models.GetCodeResult>(`${baseUrl()}`, { ...params.body })
        .then(res => { return {data: res.data, errorStatus: undefined, errorMessage: undefined} })
        .catch((e) => handleApiErrors<Models.GetCodeResult>(e))
}
